export default {"src":"/_next/static/media/lock-illustration.8c8f1a50.svg","height":120,"width":121,"blurWidth":0,"blurHeight":0};